import React, {forwardRef, useEffect, useRef, useState} from "react";
import {Checkbox, ConfigProvider, Dropdown, Input, MenuProps, Select, Spin, message} from "antd";
import {t} from "i18next";
import {
    batchUpdateGroup, deleteEmptyTags, getEmptyTagsCount,
    getGroupList,
    getTagList,
    groupByName, removeGroup,
    removeTag, tagsByGroupId,
    updateAllTagNameFromProjectCards,
    updateGroup,
    updateTag
} from "@model/tag";
import {
    removeAllCardTags,
    updateCard
} from "@model/card";
import {
    IconAddToFavor,
    IconDelete,
    IconDeleteRed,
    IconEdit, IconMenuChecked1,
    IconRemoveFavor,
    IconRename,
    IconSearchPdfCard, IconTransparent
} from "@/Icon";
import {
    generateUUID2,
    getImagePathWithTheme, getItem,
    imgPathPerfix,
    isDarkMode, isShortcuts,
    isStringNullOrEmpty,
    removeHtmlTags
} from "@/utils";
import DialogCommonInput from "@/common/DialogCommonInput";
import {getBoardCount, getNoteList, removeAllProjectTags, updateNote} from "@model/note";
import TagItemList from "@/views/Tags/TagItemList";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {
    CHECK_ALL,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_REFRESH_FAVOR,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_TAG_LSIT, EVENT_SWITCH_HOME_LIST_MENU,
    EVENT_UPDATE_NOTE, FILTER_PROJECT_CURRENT_BOARD, FILTER_PROJECT_CURRENT_PROJECT, FILTER_PROJECT_ID_ALL,
    FILTER_TAG_NO_TAGS,
    FROM_LIBRARY,
    HEADER_HEIGHT,
    KEY_ANNO_TYPES,
    KEY_FILTER_SELECT_PROJECT,
    KEY_FILTER_SELECT_TAG,
    KEY_LIBRARY_SELECTED_TYPES, KEY_SHOW_HIDIN_CARDS, KEY_TAG_LIST_FILTER_SELECT_TAG, KEY_TAG_TILTER_SELECTED_TYPES,
    MENU_SEPARATOR,
    PAGE_TITLE_MARGIN_TOP, SEARCH_WIDTH
} from "@/Const";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {getDrawPath, getFavorChildrenMenu, getSearchWidth, getTagItemPath, isMac, updateFavorToFolder} from "@/Utility";
import {useLocation} from "react-use";
import {APP_WEB_WWW} from "@/electron_interactive";
import DialogAddTag from "@/views/Tags/DialogAddTag";
import dialogCommonInput from "@/common/DialogCommonInput";
import DialogAddGroup from "@/views/Tags/DialogAddGroup";
import GroupItem from "@/views/Tags/GroupItem";
import {isZh} from "@/language";
import {ipcSend} from "@/common/ipc";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import global from "@/global";
import {Tooltip} from "../../../@excalidraw/packages/excalidraw/components/Tooltip";
import {atomSliderWidth} from "@/App";
import {atom, useAtom} from "jotai";
import {atomIsDragLine} from "@/views/Home/HomeIndex";
import {createHashHistory} from "history";
import {debugLog} from "@/LogUtils";
import DialogChangeGroup from "@/views/Tags/DialogChangeGroup";
import DialogChangeColor from "@/views/Tags/DialogChangeColor";
import dialogChangeColor from "@/views/Tags/DialogChangeColor";
import {getBoardById, getBoardList} from "@model/board";
import tagItemList from "@/views/Tags/TagItemList";
import {AutoScrollActivator, DndContext, DragEndEvent, PointerSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, horizontalListSortingStrategy, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";


let mArrayAllDatas:any;
let mArrayProjects:any = [];
let mArrayTags:any = [];
let mSelectType:any;
let mArraySelectedTypes:any=[];
let mSelectTag:string;
let mSelectProjectId:string='all';

export const atomIsTagSelectMode = atom(false);

const PageTags = forwardRef((props, ref)=>{
    const ARRAY_LIBRARY_TYPES = [
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card'
        },
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf'
        },
        {
            value:'journal',
            label:t("Journal"),
            buttonLabel:t("New journal"),
            icon:'library_type_journal'
        },
        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image'
        },
        {
            value:'liveVideo',
            label:t("Live video"),
            buttonLabel:'',
            ext:'.mp4,.mov',
            icon:'library_type_online_video'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video'
        },
        // {
        //     value:'image',
        //     label:t("Image"),
        //     buttonLabel:t("New image"),
        //     ext:'.jpg,.jpeg,.bmp,.png'
        // },
        {
            value:'audio',
            label:t("Audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3',
            icon:'library_type_audio'
        },
        {
            value:'file',
            label:t("File"),
            buttonLabel:t("New file"),
            ext:'*',
            icon:'library_type_file'
        },
        {
            value:'webLink',
            label:t("Web link"),
            buttonLabel:t("Web link"),
            ext:'*',
            icon:'library_type_weblink'
        },
        {
            value:'cardAnno',
            label:t("Card highlight"),
            buttonLabel:t("Card highlight"),
            icon:'library_type_anno'
        },
        {
            value:'pdfAnno',
            label:t("PDF Highlight"),
            buttonLabel:t("PDF"),
            ext:'.pdf',
            icon:'library_type_anno'
        },
        {
            value:'videoAnno',
            label:t("Video notes"),
            buttonLabel:t("Video"),
            ext:'.mp4',
            icon:'library_type_anno'
        },
        {
            value:'audioAnno',
            label:t("Audio notes"),
            buttonLabel:t("Audio"),
            ext:'.mp3',
            icon:'library_type_anno'
        },
        {
            value:'project',
            label:t("Project"),
            buttonLabel:t(""),
            icon:'library_type_project'
        },
        {
            value:MENU_SEPARATOR,
            label:t(""),
            buttonLabel:'',
            ext:'*'
        },
        {
            value:CHECK_ALL,
            label:t("Select all"),
            buttonLabel:'',
            ext:'*',
            icon:'library_type_all'
        }
    ]

    const [searchKey,setSearchKey] = useState('');
    const [arrayDatas,setArrayDatas] = useState([]);
    const [arrayGroups,setArrayGroups] = useState<any>([]);
    const [tagItem,setTagItem] = useState('all');
    const [isHoverAddCard,setIsHoverAddCard] = useState(false);
    const [isHoverAddTag,setIsHoverAddTag] = useState(false);
    const [isHoverAddGroup,setIsHoverAddGroup] = useState(false);
    const [operButtonName,setOperButtonName] = useState(t("Select"));
    const [pageItemHeight,setPageItemHeight] = useState(document.body.clientHeight - 116);
    const [from,setFrom] = useState('');
    const [isOpenProjectType,setIsOpenProjectType] = useState(false);
    const [arrayLibraryTypes,setArrayLibraryTypes] = useState(ARRAY_LIBRARY_TYPES);
    const [selectType,setSelectType] = useState(ARRAY_LIBRARY_TYPES[0]);

    const [selectTagValue,setSelectTagValue] = useState(t("Tags"));
    const [isOpenProjectSelect,setIsOpenProjectSelect] = useState(false);
    const [isOpenTagSelect,setIsOpenTagSelect] = useState(false);
    const [arrayTags,setArrayTags] = useState([]);
    const [arrayDbTags,setArrayDbTags] = useState([]);
    const [selectProjectValue,setSelectProjectValue] = useState(mSelectProjectId);
    const [arrayProjects,setArrayProjects] = useState([]);
    const [isClearFilterVisible,setIsClearFilterVisible] = useState(false);
    const [searchPlaceHolder,setSearchPlaceHolder] = useState(t("Search tags"));
    const [isSearching,setIsSearching] = useState(false);
    const [isShowMenu,setIsShowMenu] = useState(false);
    const [isTagSelectMode,setIsTagSelectMode] = useAtom(atomIsTagSelectMode);
    const [arraySelectedTags,setArraySelectedTags] = useState<any>([]);
    const sensors = useSensors(useSensor(PointerSensor));

    //又要统计各个tag的数量，又要快，只能这里去缓存了。
    const [arrayLibrarys,setArrayLibrarys] = useState<any>([]);
    const [arrayAllProjects,setArrayAllProjects] = useState<any>([]);
    const [arrayAllBoards,setArrayAllBoards] = useState<any>([]);

    const [activeId, setActiveId] = React.useState(null);
    const [overId, setOverId] = React.useState(null);

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);

    const dialogInputRef = useRef(null);
    const dialogAddTagRef = useRef(null);
    const tagItemListRef = useRef(null);
    const mArrayGroups = useRef(null);
    const mSelectFilterTag = useRef<any>(null);

    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    const [isDragLine,setIsDragLine] = useAtom(atomIsDragLine);
    const mLastSearchTimeoutId = useRef<any>(0);
    const mSearchKey = useRef<any>(null);
    const [menuItems,setMenuItems] = useState<MenuProps['items']>([]);
    const localParams = useLocation();
    const hashHistory = createHashHistory();
    const dialogChangeGroupRef = useRef(null);
    const dialogChangeColorRef = useRef(null);
    const mScrollGroupContainerOffsetY = useRef<any>(0);

    /**
     * 更多菜单
     */
    const getTagsMoreMenu = ()=>{
        return [
            getItem(t("DeleteEmptyTags"), 'deleteEmptyTags', (localStorage.getItem(KEY_SHOW_HIDIN_CARDS)=='true')?<IconTransparent/>:null, undefined, undefined, () => {
                const arrayEmptyTags:any = [];
                // for (let i=0;i<arrayDbTags.length;i++){
                //     const tag = arrayDbTags[i];
                //     let isExist = arrayProjects.some(p=>p.tags?.includes(tag.name));
                //     if (!isExist){
                //         isExist = arrayLibrarys.some(p=>p.tags?.includes(tag.name));
                //     }
                //     if (!isExist){
                //         isExist = arrayAllBoards.some(p=>p.tags?.includes(tag.name));
                //     }
                //     if (!isExist){
                //         arrayEmptyTags.push(tag);
                //     }
                // }
                for (let i=0;i<arrayGroups.length;i++){
                    for (let j=0;j<arrayGroups[i].items.length;j++){
                        const tag = arrayGroups[i].items[j];
                        if (!tag.count || tag?.count == 0){
                            arrayEmptyTags.push(tag);
                        }
                    }
                }
                if (arrayEmptyTags.length == 0){
                    message.info(t('NoEmptyTags'));
                }else{
                    window.showMessageBox(t("DeleteEmptyTags"),t("SureToDeleteEmptyTags").replace("{0}",`${arrayEmptyTags.length}`),t("Cancel"),t("Delete"),null,()=>{
                        deleteEmptyTags(arrayEmptyTags).then(res=>{
                            message.success(t("EmptyTagsDeleted"));
                            refreshGroupList();
                        });
                    })
                }
            }),
        ]
    }

    function onResize(event:any){
        setPageItemHeight(document.body.clientHeight - 116);
    }

    function onKeydown(e){
        // debugLog('keydown',e);
        if (e.target?.type != 'text' &&
            e.target?.tagName != 'INPUT' &&
            e.target?.type != 'textarea' &&
            e.target?.className.indexOf('ql-editor') != 0 &&
            e.target.dataset?.isedit != 'true' &&
            e.target?.className.indexOf('tiptap') != 0) {
            let arrayTags = [];
            if (tagItem != 'all'){
                arrayTags.push(tagItem);
            }
            if (isShortcuts(e,'newCard')){
                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();
                window.showDialogCard({id:crypto.randomUUID(),tags:arrayTags});
            }
        }
        if (e.key == KEYS.ESCAPE){
            //退出选择模式
            if (isTagSelectMode){
                exitSelectMode();
            }
        }
    }

    useEffect(()=>{

        recvMessage(EVENT_REFRESH_TAG_LSIT,(msg,data)=>{
            refreshTagList();
            refreshTagItemList();
        });

        //接收列表的刷新，
        recvMessage(EVENT_REFRESH_LIBRARY_LIST,(msg,data)=>{
            refreshTagItemList();
        })

        window.addEventListener('resize',onResize);

        recvMessage(EVENT_UPDATE_NOTE,(msg,data)=>{
            const card = data.data.data;
            const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
            if (isStringNullOrEmpty(removeHtmlTags(card.doc)) && isEmptyTitle && card.doc.indexOf('<img') == -1){
                return;
            }

            card.type = card.type || 'card';
            updateCard(card,true,true,'fromPageTags-EVENT_UPDATE_NOTE').then(res=>{
                refreshTagItemList();
            });
        })


        document.body.addEventListener('keydown',onKeydown);

        return ()=>{
            unSubscribe(EVENT_REFRESH_TAG_LSIT);
            unSubscribe(EVENT_REFRESH_LIBRARY_LIST);
            document.body.removeEventListener('keydown',onKeydown);
            window.removeEventListener('resize',onResize);
            unSubscribe(EVENT_UPDATE_NOTE)
        }
    })

    useEffect(()=>{
        setSearchKey('');
        setIsTagSelectMode(false);
        refreshTagList();

        //查询所有project
        getNoteList().then(res=>{
            mArrayProjects.length = 0;

            mArrayProjects.push({
                value:'all',
                label:t("Projects")
            });
            // mArrayProjects.push({
            //     value:'all-0',//allInProject
            //     label:t("All projects")
            // });
            mArrayProjects.push({
                value:'notInProject',
                label:t("Not in any project")
            })
            if (props.from == FROM_LIBRARY){
                //库里面，增加2个
                mArrayProjects.push({
                    value:FILTER_PROJECT_CURRENT_PROJECT,
                    label:t("Current project")
                })
                mArrayProjects.push({
                    value:FILTER_PROJECT_CURRENT_BOARD,
                    label:t("Current board")
                })
            }

            mArrayProjects.push({
                id:MENU_SEPARATOR,
                label:'',
                value:'spe0'
            })
            res.forEach(p=>{
                mArrayProjects.push({
                    value:p.id,
                    label:p.name || t('Untitled')
                })
            })
            setArrayProjects(mArrayProjects);
        })

        // hashHistory.listen(({location, action})=>{
        //     if (action?.toLowerCase() == 'pop'){
        //         refreshTagList();
        //     }
        // });

        window.refreshList['updateTheme_pageTags'] = forceUpdate;

        return ()=>{
            delete window.refreshList['updateTheme_pageTags'];
        }
    },[])

    useEffect(() => {
        if (localParams.state?.usr?.tag) {
            mSelectTag = localParams.state?.usr?.tag;
            setTagItem(localParams.state?.usr?.tag.name);
            setFrom('favor');
        }
        if (localParams.state?.usr?.tagItem){
            setTagItem(localParams.state?.usr?.tagItem);
        }
    }, [localParams]);

    useEffect(() => {
        if (tagItem != 'all'){
            global.g_currentTag = tagItem;
            //刷新列表.
            refreshTagItemList();
            setSearchPlaceHolder(t("Search"))
        }else{
            global.g_currentTag = '';
            setSearchPlaceHolder(t("Search tags"))
        }


        //默认全部选择--不记忆
        var arrays = [...ARRAY_LIBRARY_TYPES];
        arrays.forEach(p=>{
            p.isChecked = true;
        })
        setArrayLibraryTypes(arrays);
        mArraySelectedTypes = arrays;

        mSelectProjectId = 'all';
        setSelectProjectValue(mSelectProjectId);

        mSelectFilterTag.current = '';
        setSelectTagValue(t("Tags"));


        return ()=>{
            global.g_currentTag = '';
        }
    }, [tagItem]);

    useEffect(() => {
        mArrayGroups.current = arrayGroups;
    }, [arrayGroups]);

    /**
     * 单个标签页的tag菜单....
     */
    const getItemMenu = (tag:any)=>{
        return [{
            label: t("Edit"),
            key: 'edit',
            icon: <img className='img-mini-small mr-8 ml-1'
                       src={getImagePathWithTheme("contextmenu_edit")}/>
        },
            {
                label: tag?.isFavirated == 1 ? t('Cancel favor') : t("Add to Favorites"),
                key: 'favor',
                icon: tag?.isFavirated == 1?<IconRemoveFavor/>:<IconAddToFavor/>,
                children:getFavorChildrenMenu(tag?.isFavirated,(key)=>{
                    handleMenuClick({key: 'favor',tag:{key:key}});
                })
            },
            {
                label: <span className={isDarkMode()?'':'delete-color'}>{t("Delete")}</span>,
                key: 'delete',
                icon: <IconDeleteRed/>
            }
        ]
    }


    const refreshTagList = () => {

        getTagList().then(async (res:any)=>{
            //统计tag下project和library的数量
            // const arrayLibrarys:any = await getAllCardList();
            // const arrayProjects:any = await getNoteList();
            //
            // for (let i=0;i<res.length;i++){
            //     const item = res[i];
            //     item.count = 0;
            //     item.count += arrayLibrarys.filter(p=>p.tags?.includes(item.name)).length;
            //     item.count += arrayProjects.filter(p=>p.tags?.includes(item.name)).length;
            // }
            // mArrayAllDatas = res;
            // setArrayDatas(res);
            setArrayDbTags(res);

            global.g_arrayTagList.length = 0;
            global.g_arrayTagList.push(...res);

            mArrayTags.length = 0;
            if (res.length > 0){
                mArrayTags.push({
                    value:FILTER_TAG_NO_TAGS,
                    label:t("No tags")
                })

                mArrayTags.push({
                    id:MENU_SEPARATOR,
                    value:generateUUID2()
                })
            }

            res.forEach(p=>{
                mArrayTags.push({
                    value:p.id,
                    label:p.name
                })
            })
            setArrayTags(mArrayTags);
        })

        refreshGroupList();
    }

    const refreshGroupList = async ()=>{
        // getAllCardList().then(async (arrayLibs)=>{
        //     setArrayLibrarys(arrayLibs);
        //
        //     const arrayBoards = await getBoardList('');
        //     setArrayAllBoards(arrayBoards);
        //
        //     const arrayProjs = await getNoteList();
        //     setArrayAllProjects(arrayProjs);
        // })

        // const arrayBoards = await getBoardList('');
        // setArrayAllBoards(arrayBoards);
        //
        // const arrayProjs = await getNoteList();
        // setArrayAllProjects(arrayProjs);

        getGroupList().then(async (res)=>{
            // const arrayLibs:any = await getAllCardList();
            // const arrayProjs:any = await getNoteList();
            // setArrayLibrarys(arrayLibs);
            // setArrayAllProjects(arrayProjs);

            const arrayGroup:any = [];
            arrayGroup.push({
                id:'-1',
                value:'-1',
                dragDisabled:true,
                name:t("Ungrouped")
            })
            if (res){
                arrayGroup.push(...res);
            }

            //这里过滤一遍tag数据....
            for (let i=0;i<arrayGroup.length;i++){
                const group = arrayGroup[i];
                let arrayTags = await tagsByGroupId(group.id);
                arrayTags.forEach(p=>{
                    delete p.isSelected;
                    delete p.isChecked;
                })
                arrayTags.sort((a,b)=>{
                    if (a.createTime && b.createTime){
                        return a.createTime - b.createTime;
                    }
                    return 0;
                })
                arrayTags.sort((a,b)=>{
                    if (a.tagSort != undefined && b.tagSort != undefined){
                        return a.tagSort - b.tagSort;
                    }
                    return 0;
                })
                group.items = arrayTags;
            }

            mArrayGroups.current = arrayGroup;

            //取一下tag...
            mArrayAllDatas = await getTagList();
            setArrayDatas(mArrayAllDatas);

            if (mSelectTag){
                const p = mArrayAllDatas.find(p=>p.id == mSelectTag.id);
                if (p){
                    mSelectTag = p;
                }
            }

            setArrayGroups(arrayGroup);
        })
    }

    /**
     * 在标签列表刷新标签列表
     */
    const refreshTagItemList = ()=>{
        const arrayTypes:any = [];
        for (let i=0;i<mArraySelectedTypes.length;i++){
            if (mArraySelectedTypes[i].isChecked){
                arrayTypes.push(mArraySelectedTypes[i].value);
            }
        }
        if (arrayTypes.includes('liveVideo')){
            arrayTypes.push('bilibili');
            arrayTypes.push('youtube');
        }

        //加入board
        arrayTypes.push('board')

        tagItemListRef.current?.onRefresh(arrayTypes,mSelectProjectId,mSelectFilterTag.current,mSearchKey.current);
    }

    /**
     * 右键菜单，转到上级去处理
     * @param e
     */
    const handleMenuClick = async (e: any) => {
        if (e.key == 'edit'){
            onEditTag(t("Edit tag"),mSelectTag);
        }else if (e.key == 'delete'){
            window.showMessageBox(t("Delete tag"),t("ConfirmDeleteTag"),t("Cancel"),t("Confirm"),null,()=>{
                removeTag(mSelectTag?.id).then(res=>{
                    refreshTagList();
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                });
                //如果是在子页面，返回到上一级
                if (tagItem != 'all'){
                    setTagItem('all');
                    setFrom('');
                }

                removeAllCardTags(mSelectTag?.name);
                removeAllProjectTags(mSelectTag?.name);
            })
        }else if (e.key == 'favor'){
            mSelectTag.type = 'tag';
            mSelectTag.favirateTime = Date.now();
            mSelectTag.sort = 0;

            if (mSelectTag.isFavirated == 1){
                mSelectTag.isFavirated = 0;
            }else{
                mSelectTag.isFavirated = 1;
            }
            if (e.tag && e.tag.key){
                //保存到文件夹
                await updateFavorToFolder(e.tag.key,mSelectTag);
            }
            //保存到数据库.
            updateTag(mSelectTag).then(res=>{
                postMessage(EVENT_FAVIRIATE_CHANGE);
                refreshTagList();
            })
        }
    }

    const onEditTag = (szTitle:string,tag:any)=>{
        let szButton = t("Create tag");
        if (tag != null){
            szButton = t("Save changes");
        }
        const szOriginTagName = tag?.name;
        dialogAddTagRef.current?.onShowDialogAll(tag,szTitle,t("Cancel"),szButton,(newTag:any)=>{
            //标签名称是否存在
            const arrayFilters = mArrayAllDatas?.filter(p=>p.name.toLowerCase() == newTag.name.toLowerCase());
            let bExist = false;
            if (tag){
                if (arrayFilters.length > 0){
                    if (arrayFilters[0].id != tag.id){
                        bExist = true;
                    }
                }else{
                    bExist = arrayFilters.length > 0;
                }
            }
            if (bExist){
                message.info(t("Tag exist"));
                return;
            }
            dialogAddTagRef.current?.onCloseDialog();


            //添加...
            updateTag(newTag).then(res=>{
                //更新所有关联的标签...
                updateAllTagNameFromProjectCards(szOriginTagName,newTag.name).then(res0=>{
                    refreshTagList();
                    // //刷新标题
                    // setTagItem(newTag.name);
                    // mSelectTag = newTag;
                    if (tagItem != 'all'){
                        setTagItem(newTag.name);
                    }
                });
                //刷新收藏 ....
                postMessage(EVENT_FAVIRIATE_CHANGE);
            })
        })
    }

    const onEditGroup = (group:any)=>{
        let szButton = t("CreateGroup");
        if (group != null){
            szButton = t("Save changes");
        }
        dialogInputRef.current?.onShowDialogAll(group?.name,group == null?t("CreateGroup"):t("EditGroup"),t("Cancel"),szButton,async (szContent:any)=>{
            //标签名称是否存在
            const dbGroup = await groupByName(szContent);
            let bExist = false;
            if (dbGroup && dbGroup.id != group?.id){
                message.info(t("GroupExist"));
                return;
            }
            if (bExist){
                message.info(t("GroupExist"));
                return;
            }
            dialogInputRef.current?.onCloseDialog();
            if (group == null){
                group = {};
                group.createTime = Date.now();
            }
            group.name = szContent;
            group.updateTime = Date.now();

            //添加...
            updateGroup(group).then(res=>{
                refreshTagList();
            })
        })
    }

    /**
     * 是否是全部项目
     */
    const isAllProject = ()=>{
        return mSelectProjectId == FILTER_PROJECT_ID_ALL || mSelectProjectId == 'all-0'
    }

    /**
     * 类型条目点击....
     * @param p
     * @param isChecked
     */
    const onCheckedItemClicked = (p,isChecked)=>{
        if (props.type == 'highlight'){
            var arrayNew = [...arrayLibraryTypes];
            p.isChecked = isChecked;
            mSelectType = p;
            setSelectType(p);//when update?????????setselecttype?????

            mArraySelectedTypes = arrayNew;
            setArrayLibraryTypes(arrayNew);

            //保存到文件...
            localStorage.setItem(KEY_ANNO_TYPES,JSON.stringify(arrayNew));

            //刷新列表
            // mPageNum = 0;
            // updateList()
        }else{
            var arrayNew = [...arrayLibraryTypes];

            if (p.value == CHECK_ALL) {
                arrayNew.forEach(pp => pp.isChecked = isChecked);
            }else {
                p.isChecked = isChecked;

                mSelectType = p;
                setSelectType(p);//when update?????????setselecttype?????

                if (p.isChecked) {
                    arrayLibraryTypes.forEach(p => {
                        if (p.value == mSelectType.value) {
                            // setLeftTitle(p.label);
                        }
                    })
                }else {
                    const arraySelected = mArraySelectedTypes.filter(pp=>pp.isChecked && pp.value != p.value);
                    if (arraySelected.length >0) {
                        setSelectType(arraySelected[0]);
                    }else {
                        setSelectType({});
                    }
                }

                //判断all
                const itemAll = arrayNew[arrayNew.length -1];
                itemAll.isChecked = arrayNew.filter(pp=>pp.isChecked && pp.value != MENU_SEPARATOR && pp.value != CHECK_ALL).length == (arrayNew.length - 2);
            }

            mArraySelectedTypes = arrayNew;
            setArrayLibraryTypes(arrayNew);
            localStorage.setItem(KEY_TAG_TILTER_SELECTED_TYPES,JSON.stringify(arrayNew));

            // localStorage.setItem(KEY_LIBRARY_TYPE,mSelectType.value);

            //刷新列表
            refreshTagItemList()
        }
    }

    const patchMenuFavor = ()=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = async function (event:any){
                        handleMenuClick({key:'favor'})
                        setIsShowMenu(false);
                    }
                }
            }
        },100)
    }

    /**
     * 取标题
     */
    const getTagTitle = ()=>{
        if (isTagSelectMode){
            const szTitle =  t("TagsSelected").replace('{0}',arraySelectedTags.length);
            return szTitle;
        }
        return t("Tags");
    }

    /**
     * 退出选择模式
     */
    const exitSelectMode = ()=>{
        setIsTagSelectMode(false);
        setArraySelectedTags([]);
        const arrayNewGroups: any = [];
        for (let i = 0; i < arrayGroups.length; i++) {
            const group: any = arrayGroups[i];
            const newGroup = {...group};
            newGroup.items = [];
            for (let j = 0; j < group.items.length; j++) {
                const tag = group.items[j];
                const newTag = {...tag, isSelected: false}
                newGroup.items.push(newTag);
            }
            arrayNewGroups.push(newGroup);
        }
        setArrayGroups(arrayNewGroups);
    }

    /**
     * 删除选择的tags
     */
    const deleteSelectedTags = async ()=>{
        for (let i=0;i<arraySelectedTags.length;i++){
            const item = arraySelectedTags[i];
            await removeTag(item?.id);

            await removeAllCardTags(item?.name);
            await removeAllProjectTags(item?.name);
        }
        refreshGroupList();
        postMessage(EVENT_FAVIRIATE_CHANGE);
        exitSelectMode();
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=>{
        if (isSearching){
            return<>
                <Spin indicator={<img className={'img-16 rotating-image mr-6'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        }else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit",marginRight:'6px'}}
                        onClick={() => {
                            setSearchKey('');
                            mSearchKey.current = '';
                            setArrayDatas(mArrayAllDatas);

                            if (tagItem != 'all'){
                                setIsSearching(true);
                                refreshTagItemList()
                            }
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    // 插入指示线组件
    function InsertIndicator() {
        return (
            <div
                style={{
                    height: '2px',
                    width:'100%',
                    backgroundColor: 'var(--primary-color)',
                    margin: '4px 0',
                    borderRadius: '1px',
                }}
            />
        );
    }

    // 判断插入位置：返回应在哪个索引之后插入（-1 表示最顶部）
    const getInsertIndex = () => {
        if (activeId === null || overId === null) return -2; // 无效

        const activeIndex = arrayGroups.findIndex(i => i.id === activeId);
        const overIndex = arrayGroups.findIndex(i => i.id === overId);

        if (activeIndex === overIndex) return -2; // 同一项

        // 假设垂直列表：如果 active 在 over 上方（索引小），则插入到 over 下方（overIndex + 1）
        // 否则插入到 over 上方（overIndex）
        if (activeIndex < overIndex) {
            return overIndex; // 插入点在 over 之后 → 显示在 over item 下方
        } else {
            return overIndex - 1; // 插入点在 over 之前 → 显示在 over item 上方（即前一个 item 下方）
        }
    };

    const insertIndex = getInsertIndex();

    const handleDragStart = (event) => {
        const div = document.getElementById('div-tag-group-container');
        mScrollGroupContainerOffsetY.current = div?.scrollHeight;

        setActiveId(event.active.id);
        setOverId(null);
    };

    const handleDragOver = (event) => {
        setOverId(event.over?.id ?? null);
    };

    const handleDragMove = (event)=>{

    }

    //拖动排序的
    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        setActiveId(null);
        setOverId(null);

        if (!over) {
            return;
        }
        if (over.id == -1 || active.id == -1)return;

        if (active.id !== over.id) {
            const newArrayFrames:any = [...arrayGroups];

            const oldIndex = newArrayFrames.findIndex((item) => item.id === active.id);
            const newIndex = newArrayFrames.findIndex((item) => item.id === over.id);
            const arrayNewItem:any = arrayMove(newArrayFrames, oldIndex, newIndex);
            for (let i=0;i<arrayNewItem.length;i++){
                arrayNewItem[i].sort = i;
            }
            setArrayGroups(arrayNewItem);
            //保存排序...
            const arraySortGroups:any = arrayNewItem.filter(p=>p.id != -1);
            batchUpdateGroup(arraySortGroups);
        }
    };



    return(
        <div style={{height: '100vh',background:'var(--background-color-f9fafb)',padding: '0px 20px 12px 20px',width:`calc(100% - ${rightSliderWidth}px)`,pointerEvents:isDragLine?'none':'all'}}>
            <div className={'flex-row-vertical-center'} style={{
                // height: `${HEADER_HEIGHT}px`
                // minHeight:`${HEADER_HEIGHT}px`,
                paddingTop:'7px',
                gap:'12px 22px',//y,x
                flexWrap:'wrap',
                // overflow:'hidden'
            }}>
                <HomeNavigator margin={'0 0px 0 -4px'} onBeforeBack={()=>{
                    if (tagItem != 'all' && localParams.state?.usr?.from != 'favor' && localParams.state?.usr?.from != 'nav') {
                        setTagItem('all');
                        setFrom('');
                        refreshTagList();
                        return true;
                    }
                    return false;
                }}/>

                {
                    tagItem != 'all' &&
                    <span className='header-title font-family-semi-bold'
                          style={{
                              marginLeft:'-16px',
                              display: 'block',
                          }}>{'#'+tagItem}</span>
                }
                {
                    tagItem == 'all' &&
                    <>
                        <Input prefix={<IconSearchPdfCard/>}
                               suffix={renderSuffix()}
                               className={'input-border'}
                               variant={"borderless"}
                               style={{
                                   width: (tagItem == 'all') ? getSearchWidth() : `${SEARCH_WIDTH}px`,
                                   height: '32px',
                                   marginLeft:'-7px',
                                   // backgroundColor: 'var(--input-background-color)'
                               }}
                               placeholder={searchPlaceHolder} value={searchKey}
                               onChange={(event) => {
                                   mSearchKey.current = event.currentTarget.value.toLowerCase();
                                   setSearchKey(event.currentTarget.value);
                                   // let szSearch = event.currentTarget.value.toLowerCase();
                                   //
                                   // var arrayNewData = mArrayAllDatas.filter(p => p.name.toLowerCase().indexOf(event.currentTarget.value.toLowerCase()) >= 0);
                                   //
                                   // setArrayDatas(arrayNewData);
                                   //搜索列表
                                   if (tagItem != 'all') {
                                       setIsSearching(true);
                                       clearTimeout(mLastSearchTimeoutId.current);
                                       mLastSearchTimeoutId.current = setTimeout(() => {
                                           refreshTagItemList();
                                           clearTimeout(mLastSearchTimeoutId.current);
                                       }, 1500);
                                   }
                               }}/>
                        {
                            tagItem == 'all' && !isTagSelectMode &&
                            <div style={{padding: '0 0px', marginLeft: '0px', flexShrink: '0', marginRight: '16px',color:'var(--text-dark-gray-color)'}}
                                 className={'flex-center cursor-pointer default-font-size no-drag'}
                                 onClick={() => {
                                    setIsTagSelectMode(true);
                                 }}>{t("Select1")}</div>
                        }
                    </>
                }


                {/*分类类型切换...card - pdf image  video audio*/}
                {
                    tagItem != 'all' && false &&
                    <>
                        {
                            //region
                            <div className={'flex-row-vertical-center select-popup-class'} style={{
                                width: '138px', marginRight: '0px',
                                paddingLeft: '12px',
                                borderRadius: '8px',
                                position: 'relative',
                                height: '32px',
                                border: '1px solid var(--input-border-color)',
                                marginLeft:'0px'
                            }}>
                                <img className={'img-18'} src={getImagePathWithTheme('filter_type.svg')}/>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Select: {
                                                /* 这里是你的组件 token */
                                                colorBorder: 'transparent',
                                                colorPrimaryHover: 'transparent',
                                                colorPrimary: 'transparent',
                                            },
                                        },
                                    }}>
                                    <Select
                                        open={isOpenProjectType}
                                        value={t("Type")}
                                        style={{width: '100%',
                                            position: 'absolute',
                                            left: '0',
                                            display: 'flex',
                                            alignItems: 'center',}}
                                        options={ARRAY_LIBRARY_TYPES}
                                        onDropdownVisibleChange={(e)=>setIsOpenProjectType(e)}
                                        onChange={(value,option) => {

                                        }}
                                        dropdownRender={(menu)=>{
                                            return(
                                                <div key={'pagelibrary-tags'} style={{overflowX:'hidden',maxHeight:'620px',overflowY:'auto'}}>
                                                    <>
                                                        {
                                                            arrayLibraryTypes.map(p=>
                                                                <>
                                                                    {
                                                                        p.value == MENU_SEPARATOR &&
                                                                        <div key={p.value+p.ext} className={'line'} style={{margin:'4px 0'}}></div>
                                                                    }
                                                                    {
                                                                        p.value !== MENU_SEPARATOR &&
                                                                        <div key={p.value} className={'dropdown-item'} onMouseEnter={()=>{
                                                                            const arrayNewType = [...arrayLibraryTypes];
                                                                            arrayNewType.forEach(p=>p.isHoverd = false);
                                                                            p.isHoverd = true;
                                                                            mArraySelectedTypes = arrayNewType;
                                                                            setArrayLibraryTypes(arrayNewType);
                                                                        }} onMouseLeave={()=>{
                                                                            const arrayNewType = [...arrayLibraryTypes];
                                                                            arrayNewType.forEach(p=>p.isHoverd = false);
                                                                            mArraySelectedTypes = arrayNewType;
                                                                            setArrayLibraryTypes(arrayNewType);
                                                                        }} onClick={(event)=>{
                                                                            onCheckedItemClicked(p,!p.isChecked);
                                                                        }} style={{background:'transparent',display:'flex',alignItems:'center'}}>
                                                                            <img className={'img-16'} style={{filter:'none',marginLeft:'8px'}} src={getImagePathWithTheme(p.icon)}/>

                                                                            <span className={'span-single-line'} style={{paddingLeft: '12px',paddingRight:'12px',color:'var(--text-color)'}}>{p.label}</span>

                                                                            <div className={'flex-row-vertical-center'} style={{marginLeft:'auto'}}>
                                                                                {
                                                                                    p.isHoverd && p.value != CHECK_ALL &&
                                                                                    <Tooltip title={t("ShowOnlyThis")} arrow={false}>
                                                                                        <img style={{marginLeft: 'auto'}}
                                                                                             className={'img-16 no-filter mr-6'}
                                                                                             src={getImagePathWithTheme('library_eye_this')} onClick={(e)=>{
                                                                                            e.stopPropagation();
                                                                                            e.preventDefault();
                                                                                            setIsOpenProjectType(false);
                                                                                            //只显示这一种类型..
                                                                                            if (props.type == 'highlight') {
                                                                                                const arrayNewType = [...arrayLibraryTypes];
                                                                                                arrayNewType.forEach(item=> {
                                                                                                    item.isHoverd = false;
                                                                                                    item.isChecked = false;
                                                                                                });
                                                                                                p.isChecked = true;

                                                                                                mArraySelectedTypes = arrayNewType;
                                                                                                setArrayLibraryTypes(arrayNewType);
                                                                                                localStorage.setItem(KEY_ANNO_TYPES,JSON.stringify(arrayNewType));

                                                                                                //刷新列表
                                                                                                refreshTagItemList();
                                                                                            }else {
                                                                                                const arrayNewType = [...arrayLibraryTypes];
                                                                                                arrayNewType.forEach(item=> {
                                                                                                    item.isHoverd = false;
                                                                                                    item.isChecked = false;
                                                                                                });
                                                                                                p.isChecked = true;

                                                                                                mArraySelectedTypes = arrayNewType;
                                                                                                setArrayLibraryTypes(arrayNewType);
                                                                                                localStorage.setItem(KEY_TAG_TILTER_SELECTED_TYPES,JSON.stringify(arrayNewType));

                                                                                                //刷新列表
                                                                                                refreshTagItemList();
                                                                                            }

                                                                                        }}/>
                                                                                    </Tooltip>
                                                                                }

                                                                                <Checkbox style={{marginLeft:'4px',marginRight:'8px',pointerEvents:'none'}} checked={p.isChecked} onChange={(e)=>{
                                                                                    // onCheckedItemClicked(p,e.target.checked)
                                                                                }}></Checkbox>
                                                                            </div>

                                                                        </div>
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                </div>
                                            )
                                        }}
                                        suffixIcon={<img className='img-mini-small-10' onClick={()=>{
                                            setIsOpenProjectType(true)
                                        }}
                                                         src={getImagePathWithTheme('drop_down_select')}/>}
                                        dropdownStyle={{width: '228px', overflowY: 'auto',boxShadow: 'var(--dialog-box-shadow)'}}>
                                    </Select>
                                </ConfigProvider>

                            </div>

                            //endregion
                        }


                        {/*project 按所在项目过滤..all  all in project  not in project*/}
                        <div className={'flex-row-vertical-center select-popup-class project-filter---'} style={{
                            paddingLeft: '12px',
                            borderRadius: '8px',
                            position: 'relative',
                            height: '32px',
                            border: '1px solid var(--input-border-color)',
                            width:'138px',
                            marginLeft:'0px'
                        }}>
                            <img className={'img-18'} src={getImagePathWithTheme('filter_project.svg')}/>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Select: {
                                            /* 这里是你的组件 token */
                                            colorBorder: 'transparent',
                                            colorPrimaryHover: 'transparent',
                                            colorPrimary: 'transparent',
                                        },
                                    },
                                }}>
                                <Select
                                    dropdownClassName={'shadow'}
                                    showSearch={true}
                                    open={isOpenProjectSelect}
                                    onDropdownVisibleChange={(e)=>setIsOpenProjectSelect(e)}
                                    value={selectProjectValue}
                                    style={{width: '100%',
                                        position: 'absolute',
                                        left: '0',
                                        display: 'flex',
                                        alignItems: 'center',}}
                                    options={arrayProjects}
                                    onChange={value => {
                                        setSelectProjectValue(value);
                                    }}
                                    onSearch={value => {
                                        value = value.toLowerCase();
                                        if (isStringNullOrEmpty(value)) {
                                            setArrayProjects(mArrayProjects);
                                        }else {
                                            var arrayNewProject = mArrayProjects.filter((p)=>{
                                                return p.label?.toLowerCase().indexOf(value) != -1;
                                            });
                                            setArrayProjects(arrayNewProject);
                                        }
                                    }}
                                    dropdownRender={(menu)=>{
                                        return(
                                            <div style={{overflowX:'hidden',maxHeight:'320px',overflowY:'auto'}}>
                                                {
                                                    arrayProjects.map(p=>
                                                        <>
                                                            {
                                                                p.id == MENU_SEPARATOR &&
                                                                <div key={p.id} className={'line'} style={{margin:'4px -6px'}}></div>
                                                            }
                                                            {
                                                                p.id !== MENU_SEPARATOR && p.value != 'all' &&
                                                                <div key={p.value} className={'dropdown-item'} onClick={async ()=>{
                                                                    setIsOpenProjectSelect(false);
                                                                    setSelectProjectValue(p.label);
                                                                    mSelectProjectId = p.value;
                                                                    refreshTagItemList();
                                                                    //记忆
                                                                    localStorage.setItem(KEY_FILTER_SELECT_PROJECT,p.value);
                                                                    setIsClearFilterVisible(!isAllProject() || t('Tags') != selectTagValue);
                                                                }}>
                                                                    <span className={'span-single-line'} style={{paddingLeft: '12px',paddingRight:'12px'}}>{p.label}</span>
                                                                </div>
                                                            }
                                                        </>
                                                    )
                                                }
                                            </div>
                                        )
                                    }}
                                    suffixIcon={<img className='img-mini-small-10' onClick={()=>setIsOpenProjectSelect(true)} src={getImagePathWithTheme('drop_down_select')}/>}
                                    dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                                </Select>
                            </ConfigProvider>
                        </div>


                        {/*//标签  标签下拉*/}
                        <div className={'flex-row-vertical-center select-popup-class'} style={{
                            width:'138px',marginLeft:'0px',
                            borderRadius: '8px',
                            position: 'relative',
                            height: '32px',
                            paddingLeft: '12px',
                            border: '1px solid var(--input-border-color)',
                        }}>
                            <img className={'img-18'} src={getImagePathWithTheme('filter_tag')}/>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Select: {
                                            /* 这里是你的组件 token */
                                            colorBorder: 'transparent',
                                            colorPrimaryHover: 'transparent',
                                            colorPrimary: 'transparent',
                                        },
                                    },
                                }}>
                                <Select
                                    dropdownClassName={'shadow'}
                                    showSearch={true}
                                    open={isOpenTagSelect}
                                    onDropdownVisibleChange={(e)=>setIsOpenTagSelect(e)}
                                    value={selectTagValue}
                                    style={{width: '100%',
                                        position: 'absolute',
                                        left: '0',
                                        display: 'flex',
                                        alignItems: 'center',}}
                                    options={arrayTags}
                                    onSearch={value => {
                                        if (isStringNullOrEmpty(value)) {
                                            setArrayTags(mArrayTags);
                                        }else {
                                            var arrayNewTag = mArrayTags.filter((p)=>{
                                                return p.label?.indexOf(value) != -1;
                                            });
                                            setArrayTags(arrayNewTag);
                                        }
                                    }}
                                    dropdownRender={(menu)=>{
                                        return(
                                            <>
                                                <div style={{
                                                    overflowX: 'hidden',
                                                    maxHeight: '320px',
                                                    overflowY: 'auto',
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                }}>
                                                    {
                                                        arrayTags.map(p =>
                                                                <>
                                                                    {
                                                                        p.id == MENU_SEPARATOR &&
                                                                        <div key={p.value} className={'line'}
                                                                             style={{margin: '4px 0'}}></div>
                                                                    }
                                                                    {
                                                                        p.id !== MENU_SEPARATOR &&
                                                                        <div key={p.value} className={'dropdown-item'} onClick={() => {
                                                                            setIsOpenTagSelect(false);
                                                                            setSelectTagValue(p.label);
                                                                            if (p.value == FILTER_TAG_NO_TAGS) {
                                                                                mSelectFilterTag.current = FILTER_TAG_NO_TAGS+'-----';//没有tag的标题
                                                                            }else{
                                                                                mSelectFilterTag.current = p.label;
                                                                            }

                                                                            refreshTagItemList()

                                                                            localStorage.setItem(KEY_TAG_LIST_FILTER_SELECT_TAG, p.label);
                                                                            setIsClearFilterVisible(p.value != t('Tags') || !isAllProject())
                                                                        }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>{(p.value == FILTER_TAG_NO_TAGS?'':'#')+p.label}</span>
                                                                        </div>
                                                                    }
                                                                </>
                                                        )
                                                    }

                                                    {
                                                        arrayTags.length == 0 && //默认有个no tags 和横线....
                                                        <span style={{margin: '6px 12px 0px 12px'}}>{t("No tags yet")}</span>
                                                    }

                                                    <div style={{flexGrow: '1'}}></div>

                                                    {
                                                        props.from != FROM_LIBRARY &&
                                                        <>
                                                            <div className={'line'} style={{
                                                                margin: '6px -6px',
                                                                background: 'var(--vertical-line-color)',
                                                                flexShrink: '0'
                                                            }}></div>
                                                            {/*添加manager*/}
                                                            <div className={'flex-row-vertical-center cursor-pointer'}
                                                                 style={{padding: '6px 12px'}}
                                                                 onClick={() => {
                                                                     // dialogAllTagManagerRef.current?.onShowDialog();
                                                                     postMessage(EVENT_SWITCH_HOME_LIST_MENU, {name: 'tags'});
                                                                 }}>
                                                                <img className={'img-16'} src={getImagePathWithTheme('go_to_tags')}/>
                                                                <span className={'ml-8'}
                                                                      style={{marginTop: '1px'}}>{t("Go to tags")}</span>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                    }}
                                    suffixIcon={<img className='img-mini-small-10' onClick={() => setIsOpenTagSelect(true)}
                                                     src={getImagePathWithTheme('drop_down_select')}/>}
                                    dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                                </Select>
                            </ConfigProvider>
                        </div>


                        {/*清空 过滤条件*/}
                        {
                            isClearFilterVisible &&
                            <img style={{marginLeft: '0px'}} className={'img-16 cursor-pointer'} src={getImagePathWithTheme('reset_search')}
                                 onClick={() => {
                                     mSelectTag = '';
                                     mSelectProjectId = 'all';
                                     setSelectProjectValue('all')
                                     setSelectTagValue(t('Tags'));
                                     setIsClearFilterVisible(false);
                                     mSelectFilterTag.current = '';

                                     localStorage.setItem(KEY_FILTER_SELECT_PROJECT,'all');
                                     localStorage.setItem(KEY_FILTER_SELECT_TAG,t('Tags'))

                                     refreshTagItemList();
                                 }}/>
                        }
                    </>
                }

                {
                    tagItem != 'all' && operButtonName == t("Select") && from != 'favor' && false &&
                    <div className={'button-border-gray-style flex-center hovered-text-main-blue-color'}
                         style={{
                             minWidth: operButtonName == t("Select") ? '56px' : '106px',
                             height: '32px',
                             fontSize: '13px',
                             fontFamily:'Poppins',
                             paddingTop:'2px',//看着有点偏上，样式上不偏！
                             border: operButtonName == t("Select") ? '0px solid var(--button-no-fill-border-color)' : '1px solid var(--button-no-fill-border-color)'
                         }} onClick={() => {
                        let szDesc = '';
                        if (operButtonName == t("Select")) {
                            //当前是选择状态，点击取消
                            szDesc = (t("Cancel"));
                        } else {
                            szDesc = (t("Select"));
                        }
                        setOperButtonName(szDesc);
                        tagItemListRef.current?.onSetSelectEvent(szDesc);
                    }}>
                        {operButtonName}
                    </div>
                }

                <div style={{flexGrow: '1'}}></div>

                {
                    tagItem == 'all' && !isTagSelectMode &&
                    <>
                        <div className='button-max-height newcard-border-gray-style-no-hover flex-center font-size-12'
                             onMouseEnter={() => setIsHoverAddTag(true)}
                             onMouseLeave={() => setIsHoverAddTag(false)}
                             onClick={() => {
                                 onEditTag(t("Create tag"), null);
                             }}
                             style={{marginLeft: '1px', height: '32px', borderRadius: '8px', minWidth: '105px',color:'var(--text-dark-gray-color)'}}>
                            {/*imgPathPerfix() + (isHoverAddTag ? 'add_blue.png' : (isDarkMode() ? 'add_white.png' : 'add_tag_s.png'))*/}
                            <img className='img-14'
                                 src={getImagePathWithTheme('add_tag_s.svg')}/>
                            <span className='ml-6'>{t("Add tag")}</span>
                        </div>
                        <div className='button-max-height newcard-border-gray-style-no-hover flex-center font-size-12'
                             onMouseEnter={() => setIsHoverAddGroup(true)}
                             onMouseLeave={() => setIsHoverAddGroup(false)}
                             onClick={() => {
                                 onEditGroup(null);
                             }}
                             style={{marginLeft: '-10px', height: '32px', borderRadius: '8px', minWidth: '105px',marginRight:'-12px',color:'var(--text-dark-gray-color)',padding:'0 12px'}}>
                            {/*imgPathPerfix() + (isHoverAddGroup ? 'add_blue.png' : (isDarkMode() ? 'add_white.png' : 'add_group_s.png'))*/}
                            <img className='img-14'
                                 src={getImagePathWithTheme('add_group_s.svg')}/>
                            <span className='ml-6'>{t("AddGroup")}</span>
                        </div>

                        {/*间距一样，图标间距不一样，眼看着更接近，加一个左边距*/}
                        <div style={{display: 'flex', alignItems: 'center',marginLeft:'auto'}}>
                            <Dropdown overlayClassName='default-dropdown-style'
                                      overlayStyle={{minWidth: '160px'}}
                                      menu={{items: getTagsMoreMenu()}} trigger={['click']}>
                                <img className={'img-32 ml-0 cursor-pointer'}
                                     onClick={(e) => e.preventDefault()}
                                     src={getImagePathWithTheme('library_more_1.svg')}/>
                            </Dropdown>

                            {
                                rightSliderWidth == 0 &&
                                <img className='img-32 hovered-gray-radius'
                                     style={{
                                         marginLeft: APP_WEB_WWW ? '8px' : '8px',
                                         marginRight: '-8px',
                                         marginTop: '-0px'
                                     }}
                                     src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                                    window.openRightSlider(null, 'card');
                                }}/>
                            }
                        </div>
                    </>

                }

                {
                    /*更多*/
                    tagItem != 'all' &&
                    <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                        {/*<div className='button-max-height newcard-border-gray-style flex-center font-size-12'*/}
                        {/*     onMouseEnter={() => setIsHoverAddCard(true)}*/}
                        {/*     onMouseLeave={() => setIsHoverAddCard(false)}*/}
                        {/*     onClick={() => {*/}
                        {/*        window.showDialogCard({id:crypto.randomUUID(),tags:[tagItem]});*/}
                        {/*     }}*/}
                        {/*     style={{marginLeft: '1px', height: '32px', borderRadius: '8px', minWidth: '105px'}}>*/}
                        {/*    <img className='img-mini-small-12'*/}
                        {/*         src={imgPathPerfix() + (isHoverAddCard ? 'add_blue.png' : (isDarkMode() ? 'add_white.png' : 'add.png'))}/>*/}
                        {/*    <span className='ml-6'>{t("Add card")}</span>*/}
                        {/*</div>*/}
                        <Dropdown overlayClassName='default-dropdown-style' open={isShowMenu}
                                  overlayStyle={{minWidth: '232px'}}
                                  onOpenChange={(e) => {
                                      if (e) {
                                          setMenuItems(getItemMenu(mSelectTag));
                                      }
                                      setIsShowMenu(e);
                                      patchMenuFavor();
                                  }}
                                  forceRender={true}
                                  menu={{items: menuItems, onClick: handleMenuClick}} trigger={['click']}>
                            <img className='img-32 hovered-gray-radius ml-12'
                                 style={{marginLeft: APP_WEB_WWW ? '0px' : '8px'}}
                                 src={getImagePathWithTheme('library_more')}/>
                        </Dropdown>

                        {
                            rightSliderWidth == 0 &&
                            <img className='img-32 hovered-gray-radius'
                                 style={{
                                     marginLeft: APP_WEB_WWW ? '8px' : '8px',
                                     marginRight: '-9px',
                                     marginTop: '-1px'
                                 }}
                                 src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                                window.openRightSlider(null, 'card');
                            }}/>
                        }
                    </div>
                }

            </div>

            {/*标题名称*/}
            {
                //tag列表部分....
                tagItem == 'all' &&
                <>
                    <div className={'flex-row-vertical-center'}
                         style={{marginTop: `${PAGE_TITLE_MARGIN_TOP}px`, marginBottom: '1px',minHeight:'32px'}}>
                        <span className='header-title font-family-semi-bold'
                              style={{
                                  display: 'block',
                                  marginTop:'8px'
                              }}>{getTagTitle()}</span>

                        {
                            isTagSelectMode &&
                            <>
                                {
                                    <div className={'button-border-gray-style flex-center ml-16'}
                                         style={{
                                             minWidth: '76px',
                                             height: '32px',
                                             fontSize: '13px',
                                             border: '1px solid var(--button-no-fill-border-color)'
                                         }} onClick={() => {
                                        //退出选择模式
                                        exitSelectMode();
                                    }}>
                                        {t("Cancel")}
                                    </div>
                                }

                                {
                                    <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                                        <div style={{minWidth: '130px', height: '32px', marginLeft: '16px',}}
                                             onClick={() => {
                                                 //取选中的.
                                                 if (arraySelectedTags.length == 0) {
                                                    message.error(t("PleaseSelectTagBefore"));
                                                 }else {
                                                     dialogChangeGroupRef.current?.onShowDialog(arraySelectedTags);
                                                 }
                                             }}
                                             className={'button-border-gray-style flex-center'}>{t("Change group")}</div>

                                        <div className={'button-border-gray-style flex-center ml-16'} onClick={() => {
                                            if (arraySelectedTags.length == 0) {
                                                message.error(t("PleaseSelectTagBefore"));
                                                return;
                                            }
                                            dialogChangeColorRef.current?.onShowDialog(arraySelectedTags);
                                        }} style={{minWidth: '132px', height: '32px'}}>
                                            {t("Change color")}
                                        </div>

                                        <div style={{minWidth: '80px', marginLeft: '16px', height: '32px'}} onClick={() => {
                                            if (arraySelectedTags.length == 0) {
                                                message.error(t("PleaseSelectTagBefore"));
                                                return;
                                            }
                                            //删除选择的.
                                            window.showMessageBox(t("Delete tag"),t("SureToDeleteSelectedTags"),t('Cancel'),t("Confirm"),null, async ()=> {
                            deleteSelectedTags();
                                            });
                                        }}
                                             className={'button-border-danger-style flex-center'}>{t("Delete")}
                                        </div>
                                    </div>
                                }
                            </>
                        }

                    </div>


                    <div style={{height:'20px'}}></div>
                    {
                        (arrayDatas.length > 0 || arrayGroups.length > 1) &&
                        <DndContext sensors={sensors} autoScroll={{
                            enabled:true,
                            canScroll:(element)=> {
                                const div = document.getElementById('div-tag-group-container');
                                if (div) {
                                    let nH = div?.scrollTop + div?.offsetHeight;
                                    if (nH > mScrollGroupContainerOffsetY.current) {
                                        return false;
                                    }
                                }
                                return true;
                            }
                        }} onDragStart={handleDragStart} onDragOver={handleDragOver} onDragMove={handleDragMove} onDragEnd={handleDragEnd} collisionDetection={closestCenter}>
                            <SortableContext items={arrayGroups.filter(p=>!p.dragDisabled)} strategy={verticalListSortingStrategy}>
                                <div id={'div-tag-group-container'} style={{
                                    overflow: 'hidden auto',
                                    height: `${document.body.clientHeight - (isMac() ? 126 : 156)}px`,
                                    margin: '0 -20px',
                                    padding: '0 20px',
                                }}>
                                    {
                                        arrayGroups.map((p,index) => {
                                            return (
                                                <>
                                                    <GroupItem group={p} arrayAllTags={arrayDbTags} searchKey={searchKey}
                                                               arrayLibrarys={arrayLibrarys}
                                                               arrayProjects={arrayAllProjects} arrayBoards={arrayAllBoards}
                                                               onEditGroup={(group: any) => {
                                                                   onEditGroup(group);
                                                               }} onAddTag={(group: any) => {
                                                        onEditTag(t("Create tag"), {
                                                            name: '',
                                                            groupId: group.id,
                                                            createTime: Date.now()
                                                        });
                                                    }} onDeleteGroup={(group: any) => {
                                                        window.showMessageBox(t("AreYouSure"), t("ThisWillDeleteTheGroup"), t("Cancel"), t("Delete"), null, () => {
                                                            removeGroup(group.id).then(res => {
                                                                refreshTagList();
                                                            });
                                                        })
                                                    }} onTagAction={(szAction: any, tag: any) => {
                                                        if (isTagSelectMode) {
                                                            const arrayNew = [...arraySelectedTags];
                                                            if (tag.isSelected) {
                                                                arrayNew.push(tag);
                                                            } else {
                                                                const nIndex = arrayNew.findIndex(p => p.id == tag.id);
                                                                if (nIndex != -1) {
                                                                    arrayNew.splice(nIndex, 1);
                                                                }
                                                            }
                                                            setArraySelectedTags(arrayNew);
                                                        } else {
                                                            mSelectTag = tag;
                                                            //清空搜索
                                                            mSearchKey.current = '';
                                                            setSearchKey('');
                                                            if (szAction == 'click') {
                                                                window.navigateOrigin(getTagItemPath(), {state: {tagItem: tag}})
                                                                // setTagItem(tag.name);
                                                            } else {
                                                                handleMenuClick({key: szAction, tag});
                                                            }
                                                        }
                                                    }} onRefreshTag={(arrayNewTags:any)=>{
                                                        p.items = arrayNewTags;
                                                    }}/>

                                                    {/* 在每个 item 下方可能显示插入线 */}
                                                    {/*{insertIndex === index && <InsertIndicator />}*/}
                                                </>
                                            )
                                        })
                                    }
                                    {/* 如果插入位置在最顶部（index = -1） */}
                                    {/*{insertIndex === -1 && <InsertIndicator />}*/}
                                </div>
                            </SortableContext>
                        </DndContext>
                    }

                    {
                        (arrayDatas.length == 0 && arrayGroups.length <= 1) &&
                        <span style={{
                            position: 'inherit', background: 'transparent',
                            color: 'var(--text-color-66666)',
                            whiteSpace: 'pre-wrap',
                            textAlign: 'center'
                        }}>{t("NoTagsOrGroupsYet")}</span>
                    }
                </>
            }

            {
                tagItem != 'all' &&
                <div style={{height: `${pageItemHeight}px`}}>
                    <TagItemList ref={tagItemListRef} tagName={tagItem} from={from} onBackCallback={() => {
                        setTagItem('all');
                        setOperButtonName(t('Select'))
                        //刷新...
                        refreshTagList();
                    }} onCancelCallback={() => {
                        setOperButtonName(t('Select'))
                    }} onSelectCallback={() => {
                        setOperButtonName(t('Cancel'))
                    }} onRefreshDataFinished={() => {
                        setIsSearching(false);
                    }}/>
                </div>

            }

            <DialogAddGroup ref={dialogInputRef}/>
            <DialogAddTag ref={dialogAddTagRef}/>
            <DialogChangeGroup ref={dialogChangeGroupRef} onUpdate={() => {
                //刷新列表...
                refreshGroupList();
                exitSelectMode();
            }}/>
            <DialogChangeColor ref={dialogChangeColorRef} onUpdate={() => {
                //刷新列表...
                refreshGroupList();
                exitSelectMode();
                //刷新收藏
                postMessage(EVENT_FAVIRIATE_CHANGE);
            }}/>

            {
                <div style={{width: `${rightSliderWidth}px`}}></div>
            }

        </div>
    )
})
export default React.memo(PageTags);